import React from 'react';
import PropTypes from 'prop-types';

import {
    Loading,
    Prize,
    Text
} from '../../components';

const PrizeList = props => {
    const {
        emptyMessage,
        error,
        errorMessage,
        identityTaxVerified,
        loading,
        messages,
        offlinePayment,
        displayName,
        prizes,
        history,
        isValidationTaxProfile
    } = props;

    if (error) {
        return <Text as="div" left={32} right={32}>{errorMessage}</Text>;
    } else if (loading) {
        return <Loading margin={32} />;
    } else if (prizes.length === 0) {
        return <Text as="div" left={32} right={32}>{emptyMessage}</Text>;
    }

    return (
        <div className="competitive-prize-list">
            {
                prizes.map(prize => (
                    <Prize
                        key={prize.prizeId}
                        {...prize}
                        history={history}
                        isValidationTaxProfile={isValidationTaxProfile}
                        displayName={displayName}
                        identityTaxVerified={identityTaxVerified}
                        offlinePayment={offlinePayment}
                        messages={messages}
                    />
                ))
            }
        </div>
    );
};

PrizeList.propTypes = {
    emptyMessage: PropTypes.string,
    error: PropTypes.bool,
    offlinePayment: PropTypes.bool,
    errorMessage: PropTypes.string,
    identityTaxVerified: PropTypes.bool,
    loading: PropTypes.bool,
    messages: PropTypes.object,
    displayName: PropTypes.object,
    prizes: PropTypes.array,
    history: PropTypes.object,
    isValidationTaxProfile: PropTypes.bool
};

PrizeList.defaultProps = {
    prizes: []
};

export default PrizeList;
